import { useHistory, useParams } from "react-router-dom";
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import {
    isValidElement,
    isValidString,
} from "../../util/ApiHelper";
import { formatDate } from "../../util/helper";
import { Card, Image, List, notification } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { fetchStart, fetchSuccess } from "../../appRedux/actions";
import { axiosInstance, BASE_API_CONFIG } from "../../util/Api";


const OfferProductAdminView = () => {
    const history = useHistory();
    const { isMobile } = useGetBreakpoints();
    const dispatch = useDispatch();
    const { id } = useParams();
    const [adminOfferProduct, setAdminOfferProduct] = useState(null);
    const [fileName, setFileName] = useState("");


    const getAdminOfferProductById = async () => {
        try {
            dispatch(fetchStart());
            const response = await axiosInstance.get(
                `${BASE_API_CONFIG.baseURL}/admin-offer-products/${id}`
            )
            setAdminOfferProduct(response?.data)
        } catch (error) {
            notification.error({
                message: "Failed",
                description: error?.response?.data?.message || "Failed to fetch offer details"
            })
        } finally {
            dispatch(fetchSuccess());
        }
    }

    useEffect(() => {
        if (id) {
            getAdminOfferProductById()
        }
    }, [])

    useEffect(() => {
        const images = adminOfferProduct?.primaryImage;
        if (Array.isArray(images)) {
            setFileName(images);
        } else if (typeof images === "string" && images) {
            setFileName([{ src: images }]);
        }
    }, [adminOfferProduct]);

    const data = [
        {
            label: "Posted Date",
            value: formatDate(adminOfferProduct?.createdAt),
        },
        {
            label: "Product Name",
            value: adminOfferProduct?.name,
        },
        {
            label: "FOB/FOR Price",
            value: `${adminOfferProduct?.currency} ${adminOfferProduct?.price} / ${adminOfferProduct?.uom}`,
        },
        {
            label: "Payment Terms",
            value: adminOfferProduct?.comments,
        },
    ];

    return (
        isValidElement(adminOfferProduct) && (
            <Card className="myexim-detail-card">
                <div className="myexim-table-title">
                    <div>
                        <LeftOutlined
                            style={{ fontSize: "20px", color: '#434E5B' }}
                            size="large"
                            onClick={() => {
                                history.goBack();
                            }}
                        />
                    </div>
                    Offer Product Details
                </div>
                <div
                    className={`logo-with-list gx-mt-4 ${isMobile ? "gx-flex-column" : ""
                        }`}
                >
                    <div style={{ paddingRight: 16 }}>
                        {isValidString(adminOfferProduct?.primaryImage) && (
                            <div className={"logo-container"}>
                                <div className={"logo-image"}>
                                    <img
                                        alt="..."
                                        src={adminOfferProduct?.primaryImage}
                                        width={isMobile ? "100%" : 120}
                                        height={isMobile ? "100%" : 120}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                    <div style={{ flex: 1 }}>
                        <List
                            itemLayout="horizontal"
                            dataSource={data}
                            renderItem={(item) =>
                                item?.value && (
                                    <List.Item className="myexim-details-list">
                                        <List.Item.Meta
                                            title={<div>{item.label}</div>}
                                            description={isValidString(item.value) ? item.value : "-"}
                                        />
                                    </List.Item>
                                )
                            }
                        />
                        {fileName?.length > 0 && (
                            <div className="attachments gx-mt-3">
                                <div className="sub-header ">Attachments</div>
                                <div className="gx-mt-4">
                                    Please find the below attachment as a reference
                                </div>
                                <div className="gx-pt-4">
                                    {fileName?.map((file, index) => (
                                        <div key={index} className="gx-pb-3">
                                            <Image
                                                className="gx-rounded-lg"
                                                width={isMobile ? "100%" : 150}
                                                height={isMobile ? "100%" : 150}
                                                src={file?.src}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </Card>
        )
    );
};

export default OfferProductAdminView;

